import { httpCreate } from './http';

const http = httpCreate('/srv/sms-consume-record');

export const smsConsumeRecord = {
	getUserSmsInfo(params) {
		return http.get('', { params });
	},
};
